import script from "./JoinBusinessModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./JoinBusinessModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__